export default {
  MuiDataGrid: {
    defaultProps: {
      hideFooter: true,
      disableColumnMenu: true,
      paginationMode: "server", // Avoid limiting displayed rows - by default 100 rows are displayed
    },
    styleOverrides: {
      root: {
        border: "none",
        "& .MuiDataGrid-columnHeaderTitle": {
          fontWeight: 700,
        },
      },
    },
  },
};
